
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class BacMenu extends Vue {
  showGoogleTranslate () {
    const googleTranslateScript = document.createElement('script')
    googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    googleTranslateScript.addEventListener('load', () => {
      setTimeout(() => {
        const translateElement = new (window as any).google.translate.TranslateElement({
          pageLanguage: 'de'
        }
        , 'google_translate_element')
      }, 1000)
    })
    document.documentElement.appendChild(googleTranslateScript)
  }

  get showAdminArea (): boolean {
    if (!this.$store.state.LoggedInUser.user) {
      return false
    }
    if (this.$store.state.LoggedInUser.user.isAdmin) {
      return true
    }
    if (this.$store.state.LoggedInUser.user.hasRallyRoundPermissions) {
      return true
    }
    return false
  }
}
